export class KeywordsTranslator {
    static keywordMapping = new Map<string, string> ([
        ['Namespace', '命名空间'],
        ['Namespaces', '命名空间'],    
        ['Constructor', '构造函数'],                
        ['Class', '类'],
        ['Classes', '类'],        
        ['Members', '成员'],
        ['Member', '成员'],
        ['Properties', '属性'],
        ['Property', '属性'],        
        ['Methods', '方法'],
        ['Method', '方法'],        
        ['Events', '事件'],
        ['Event', '事件'],        
        ['Enumeration', '枚举'],
        ['Enumerations', '枚举'],        
        ['Name', '名称'],
        ['Description', '描述'],
        ['Exception', '异常'],
        ['Exceptions', '异常'],
        ['See Also', '参阅'],
        ['See Also', '参阅'],
        ['Syntax', '语法'],
        ['Assembly','程序集'],
        ['Since', '自'],
        ['Return Value', '返回值'],
        ['Remarks', '备注'],
        ['Parameters', '参数'],
        ['Inheritance Hierarchy', '继承树'],
        ['Implements', '实现'],
        ['Condition', '触发条件'],
        ['Examples','示例'],
        ['Example','示例'],        
        ['Member name','名称'],
        ['Constructors', '构造函数']

    ])
    static translate(keyword: string): string {
        keyword = keyword.trim();
        keyword = keyword.replace(/&nbsp;/g, ' ');
        
        let translated =  this.keywordMapping.get(keyword.trim());
        if (translated === undefined && keyword.endsWith(':')) {
            translated = this.keywordMapping.get(keyword.slice(0, keyword.length-1));
            if (translated) {
                translated = translated + ':';
            }
        }
        return translated || keyword;
    }
    static translateTitle(title: string) {
        const words = title.trim().split(' ');
        words[words.length - 1] = KeywordsTranslator.translate(words[words.length - 1]);
        return words.join(' ');    
    }    
}